import ACTS from '../constants';
  
const defaultState = {
  isLogin: false,
  lastScrapDate: '',
  certifyOnOff: '미등록',
  agencyList: null,

  viewChangeCounter: 0,
  active: ''
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ACTS.APP_LOAD:
      return {
        ...state,
        appLoaded: true,
        user: !action.error && action.payload ? action.payload.item : null,
        redirectTo: action.payload ? null : '/login'
      };

    case ACTS.LOGIN:
        return {
            ...state,
            isLogin: action.payload.result
        }    
    case ACTS.AGENCY:        
        return {
          ...state,
          agencyList : action.payload.item.AGENCY_LIST
        }
        
    case ACTS.AGENCY_UNLOADED:
        let temp = {...state};
        delete temp.agencyList;

        return temp;

    case ACTS.LOGOUT:
      return { ...state, redirectTo: '/login', token: null, user: null };

    case ACTS.ASYNC_START:
        return {
          ...state,
          loading: true
        }
        
    case ACTS.ASYNC_END:
      return {
        ...state,
        loading: false
      }

    case ACTS.LOAD_SCRAP_LAST_DATE:
      return { ...state, lastScrapDate: !action.error && action.payload ? action.payload.item.scrapLastdate === null ? '' : new Date(action.payload.item.scrapLastdate).asString('yy/mm/dd hh:MM') : '' };

    case ACTS.GET_BUSINESS_KIND_LIST:        
        return {
          ...state,
          businessKindList : action.payload.item.cds
        }

        


      

    case ACTS.REDIRECT:
      return { ...state, redirectTo: null };

    case ACTS.UPDATE_CERTIFY_ON_OFF:
      return { ...state, certifyOnOff: action.certifyOnOff };
      
    case ACTS.REGISTER:
      return {
        ...state,
        redirectTo: action.error ? null : (!state.redirectTo ? '/changeBook/move' : null) ,
        token: action.error ? null : action.payload.accessToken,
        user: action.error ? null : action.payload.user
      };

    case ACTS.ENTER_BOOK:
    return {
        ...state,
        redirectTo: action.error ? null : (!state.redirectTo ? action.payload.info.kind === 'OK' ? '/asset/list?kind='+action.payload.info.kind : '/myBook/card' : null) ,
        token: action.error ? null : action.payload.accessToken
      };
      
    case ACTS.LOGIN_PAGE_UNLOADED:
    case ACTS.REGISTER_PAGE_UNLOADED:
      return { ...state, viewChangeCounter: state.viewChangeCounter + 1 };

    
    case ACTS.UPDATE_STARTDAY: 
        if(action.error) return state;

        window.sessionStorage.setItem('startday', action.day);
        return state;
      
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/common.js